import {
  NodeModel,
  PortModel,
  PortModelGenerics,
  DefaultPortModel,
  PortModelAlignment
} from '@projectstorm/react-diagrams'
import { BaseModelOptions } from '@projectstorm/react-canvas-core'

import { buildBackendSystemPortName, nodeType } from './index'
import { OnClickComponent, OnRowsRendered } from '../index'
import { ApplicationArchitectureComponent } from '../../application-architecture-components-loader'

interface Options extends BaseModelOptions {
  readonly onRowsRendered: OnRowsRendered
  readonly onClickComponent: OnClickComponent
  readonly items: ApplicationArchitectureComponent[]
  readonly isLoading: boolean
}

export class BackendSystemsNodeModel extends NodeModel {
  public onRowsRendered: Options['onRowsRendered']
  public onClickComponent: Options['onClickComponent']
  public items: Options['items']
  public isLoading: Options['isLoading']

  public constructor(options: Options) {
    super({
      ...options,
      type: nodeType
    })

    this.onRowsRendered = options.onRowsRendered
    this.onClickComponent = options.onClickComponent
    this.items = options.items
    this.isLoading = options.isLoading
  }

  public serialize() {
    return {
      ...super.serialize(),
      onRowsRendered: this.onRowsRendered,
      onClickComponent: this.onClickComponent,
      items: this.items,
      isLoading: this.isLoading
    }
  }

  public deserialize(event): void {
    super.deserialize(event)
    this.onRowsRendered = event.data.onRowsRendered
    this.onClickComponent = event.data.onClickComponen
    this.items = event.data.items
    this.isLoading = event.data.isLoading
  }

  public removePortsAndLinks() {
    const ports = this.getPorts()

    for (const portsKey in ports) {
      if (ports[portsKey]) {
        this.removePortAndLinks(ports[portsKey])
      }
    }
  }

  public createNewPorts(startIndex: number, stopIndex: number) {
    for (let i = startIndex; i <= stopIndex; i++) {
      this.addPort(
        new DefaultPortModel({
          in: true,
          name: buildBackendSystemPortName(i, 'in'),
          alignment: PortModelAlignment.LEFT
        })
      )

      this.addPort(
        new DefaultPortModel({
          in: false,
          name: buildBackendSystemPortName(i, 'out'),
          alignment: PortModelAlignment.RIGHT
        })
      )
    }
  }

  private removePortAndLinks(port: PortModel<PortModelGenerics>) {
    const links = port.getLinks()

    for (const linkKey in links) {
      if (links[linkKey]) {
        links[linkKey].remove()
      }
    }
    this.removePort(port)
  }
}
